/*
************
****************
Main Page Scripting
****************
************
*/

$(function () {
  // Only run this on the main page...
  if (document.location.pathname !== '/') return;

  var shareBtns = $("#shareBtns"),
      shareTopOffset = shareBtns.offset().top,
      $window = $(window);

  $window.on("scroll", setSharePosition);
  $window.on("resize", setSharePosition);

  function setSharePosition () {
    var $width = $window.width();
    var playbookOffset = $('.playbook').offset().left;
    var rightOffset = $width - playbookOffset * 2 + 19;

    if ($width > 1229) {
      rightOffset = $width - playbookOffset * 2 + 19;
      shareTopOffset = 985.25;
    } else if ($width <= 1229 && $width > 991) {
      rightOffset = $width - playbookOffset * 2 + 15;
      shareTopOffset = 823;
    } else {
      rightOffset = $width - playbookOffset * 2 + 5;
      shareTopOffset = 783.59375;
    }

    if ($window.scrollTop() > shareTopOffset - 5) {
      shareBtns.addClass('shareFixed');
      shareBtns.css('right', rightOffset);
    } else {
      shareBtns.removeClass('shareFixed');
      shareBtns.css('right', '');
    }
  }
});

$(function () {
  // Only run this on the main page...
  if (document.location.pathname !== '/') return;

  var stickySide = $("#stickySide"),
      $window = $(window);

  $window.on("scroll", setStickyPosition);
  $window.on("resize", setStickyPosition);
  setStickyPosition();

  function setStickyPosition () {
    var $width = $window.width();
    var playbookOffset = $('.playbook').offset().left;
    var leftOffset = $width - playbookOffset + 6;

    if ($window.scrollTop() >= 1357) {
      stickySide.show();
      stickySide.addClass('stickyFixed');
      stickySide.css('left', leftOffset);
    } else {
      stickySide.hide();
      stickySide.removeClass('stickyFixed');
      stickySide.css('left', '');
    }
  }
});











/*
************
****************
Contest Form - Main Page
****************
************
*/

$(function () {
  // Only run this on the main page...
  if (document.location.pathname !== '/') return;

	var is_sending = false,
      failure_message = 'Whoops, looks like there was a problem. Please try again later.';

    $('#contest').submit(function (e) {
        if (is_sending || !validateInputs($(this))) return false;

        e.preventDefault();
        var $this = $(this);
        $.ajax({
          url: '/form-handlers/klaviyo.php',
          type: 'post',
          dataType: 'JSON',
          data: $this.serialize(),
          beforeSend: function () {
            is_sending = true;
          },
          error: handleFormError,
          success: function (response) {
            if (response.status && response.status === 'error') {
            	if (response.code && response.code === 214) {
            		// Already subscribed...
            		$('#contest').hide();
	                $('.form-already-subscribed').fadeIn();
            	} else {
            		handleFormError();
            	}
            }
            if (response.status && response.status === 'success') {
                $('#contest').hide();
                $('.form-success').fadeIn();
            }
            is_sending = false;
          }
        });
    });

    function handleFormError () {
        is_sending = false; // Reset the is_sending var so they can try again...
        alert(failure_message);
    }

    function validateInputs ($form) {
        // var $name = $form.find('input[name="FNAME"]').val();
        // if (!$name) {
        //   alert('You must provide your first name to enter the contest.');
        //   return false;
        // }
        var $email = $form.find('input[name="email"]').val();
        if (!$email) {
          alert('You must provide your email address to enter the contest.');
          return false;
        }
        return true;
    }
});











/*
************
****************
Bonus Form - Bonus Page
****************
************
*/

$(function () {
  // Only run this on the bonus page...
  if (document.location.pathname !== '/bonus/') return;

  var is_sending = false,
      failure_message = 'Whoops, looks like there was a problem. Please try again later.';

    $('#bonus').submit(function (e) {
        if (is_sending || !validateInputs($(this))) return false;

        e.preventDefault();
        var $this = $(this);
        $.ajax({
          url: '/form-handlers/klaviyo.php',
          type: 'post',
          dataType: 'JSON',
          data: $this.serialize(),
          beforeSend: function () {
            is_sending = true;
          },
          error: handleFormError,
          success: function (response) {
            if (response.status && response.status === 'error') {
              if (response.code && response.code === 214) {
                // Already subscribed...
                $('#bonus').hide();
                $('.form-already-subscribed').fadeIn();
                setTimeout(function () {
                  window.location.href = 'https://www.workoutmotivationbook.com/thank-you/';
                }, 2000);
              } else {
                handleFormError();
              }
            }
            if (response.status && response.status === 'success') {
              $('#bonus').hide();
              $('.form-success').fadeIn();
              setTimeout(function () {
                window.location.href = 'https://www.workoutmotivationbook.com/thank-you/';
              }, 2000);
            }
            is_sending = false;
          }
        });
    });

    function handleFormError () {
        is_sending = false; // Reset the is_sending var so they can try again...
        alert(failure_message);
    }

    function validateInputs ($form) {
        // var $name = $form.find('input[name="FNAME"]').val();
        // if (!$name) {
        //   alert('You must provide your first name to enter the contest.');
        //   return false;
        // }
        var $email = $form.find('input[name="email"]').val();
        if (!$email) {
          alert('You must provide your email address to get your bonus material.');
          return false;
        }
        return true;
    }
});











/*
************
****************
Thank You Page Scripting
****************
************
*/

$(function () {
  $('#coupon-reveal').click(function (e) {
    e.preventDefault();
    $('.hidden-coupon').slideDown();
  });
});
